<template>
  <div
    :class="_class"
    v-if="(!_lazy || loaded) || _active"
  >
    <!-- @slot content 内容 -->
    <slot />
  </div>
</template>

<script>
const name = 'ten-tabs-pane';
let paneId = 0;
export default {
  name,
  props: {
    /**
     * tab 标签文字
     */
    label: {
      type: String,
    },
    /**
     * tab 标签值
     */
    value: [String, Number],
    /**
     * 提示待处理
     */
    information: {
      type: Boolean,
      default: false,
    },
    icon: String,
    /**
     * @ignore
     * 同 closable，将废弃
     */
    closeTab: {
      type: Boolean,
      default: false,
    },
    /**
     * 标签是否可关闭
     */
    closable: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否需要 lazyload，优先级高于 tabs 组件的 lazy 属性
     */
    lazy: Boolean,
  },
  data() {
    paneId += 1;
    return {
      loaded: false,
      paneId,
    };
  },
  inject: [
    'tabs',
  ],
  computed: {
    _class() {
      const name = 'ten-tabs-tabpane';
      return [
        name,
        {
          [`${name}--active`]: this._active,
        },
      ];
    },
    _lazy() {
      if ('lazy' in this.$vnode.componentOptions.propsData) {
        return this.lazy;
      }
      return this.tabs.lazy;
    },
    _dataValue() {
      return typeof this.value !== 'undefined' ? this.value : `ten-pane-id${this.paneId}`;
    },
    _active() {
      return this._dataValue === this.tabs.curValue;
    },
  },
  watch: {
    _active: {
      handler(v) {
        if (!this.loaded && v) {
          this.loaded = true;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.tabs.$emit('pane-updated');
  },
  updated() {
    this.tabs.$emit('pane-updated');
  },
  destroyed() {
    this.tabs.$emit('pane-updated');
  },

};
</script>
